import { Row } from "@tanstack/react-table";
import { OffHoursSchedule2 } from "../../../../../../../services/cloudchipr.api";
import { frequencySortingFn } from "../../../../common/utils/sortingFunctions/frequencySortingFn";

export const offHoursFrequencySortingFn = (
  currentRow: Row<OffHoursSchedule2>,
  nextRow: Row<OffHoursSchedule2>,
) => {
  const current = currentRow.original.start_cron;
  const next = nextRow.original.start_cron;

  return frequencySortingFn(current, next);
};
